/**
 * Declared crawlers, scrapers, headless browsers and scripting HTTP clients.
 * Kept conservative so we don't discard real users' errors.
 */
const BOT_USER_AGENT_PATTERN =
  /bot|crawl|spider|slurp|mediapartners|headless|phantom|puppeteer|playwright|selenium|scrapy|curl|wget|python-requests|axios|facebookexternalhit|bingpreview|lighthouse|pingdom|gtmetrix|semrush|ahrefs|mj12|dotbot|petalbot|bytespider|dataprovider/i;

/**
 * Best-effort detection of automated traffic. Crawlers and scrapers hit the data
 * APIs at volume with keys and origins that get rejected, which isn't a user
 * problem we can fix.
 *
 * Only catches automation that declares itself through a bot user agent, the
 * webdriver flag, or a missing user agent. A scraper spoofing a real browser
 * can't be identified from the client, and is better handled by a WAF, API rate
 * limiting, or a Sentry inbound filter.
 */
export const isLikelyBot = (): boolean => {
  if (typeof navigator === "undefined") return false;
  if (navigator.webdriver) return true;

  const userAgent = navigator.userAgent || "";
  // Real browsers always send a user agent; an empty one implies a script.
  if (!userAgent) return true;

  return BOT_USER_AGENT_PATTERN.test(userAgent);
};
